// Loan constants
export const MAX_LOAN_LIMIT = 50000;

// Service fee structure
export const SERVICE_FEES = [
  { fee: 80, loanAmount: 2500, description: "Pay Kes 80 to get Kes 2,500" },
  { fee: 100, loanAmount: 5000, description: "Pay Kes 100 to get Kes 5,000" },
  { fee: 120, loanAmount: 7500, description: "Pay Kes 120 to get Kes 7,500" },
  { fee: 140, loanAmount: 10000, description: "Pay Kes 140 to get Kes 10,000" },
  { fee: 160, loanAmount: 15000, description: "Pay Kes 160 to get Kes 15,000" },
  { fee: 180, loanAmount: 20000, description: "Pay Kes 180 to get Kes 20,000" },
  { fee: 200, loanAmount: 30000, description: "Pay Kes 200 to get Kes 30,000" },
  { fee: 250, loanAmount: 50000, description: "Pay Kes 250 to get Kes 50,000" }
];

// Till number for payments
export const TILL_NUMBER = "5628444";
export const TILL_NAME = "MOONLIGHT ENTERPRISE";

// Application statuses
export const APPLICATION_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

// Form options
export const COUNTIES = [
  'Nairobi', 'Mombasa', 'Kwale', 'Kilifi', 'Tana River', 'Lamu', 'Taita Taveta',
  'Garissa', 'Wajir', 'Mandera', 'Marsabit', 'Isiolo', 'Meru', 'Tharaka Nithi',
  'Embu', 'Kitui', 'Machakos', 'Makueni', 'Nyandarua', 'Nyeri', 'Kirinyaga',
  'Murang\'a', 'Kiambu', 'Turkana', 'West Pokot', 'Samburu', 'Trans Nzoia',
  'Uasin Gishu', 'Elgeyo Marakwet', 'Nandi', 'Baringo', 'Laikipia', 'Nakuru',
  'Narok', 'Kajiado', 'Kericho', 'Bomet', 'Kakamega', 'Vihiga', 'Bungoma',
  'Busia', 'Siaya', 'Kisumu', 'Homa Bay', 'Migori', 'Kisii', 'Nyamira'
];

export const GENDER_OPTIONS = ['Male', 'Female'];

export const MARITAL_STATUS_OPTIONS = [
  'Single', 'Married', 'Divorced', 'Widowed'
];

export const EDUCATION_LEVELS = [
  'Primary', 'Secondary', 'Certificate', 'Diploma', 'Degree', 'Masters', 'PhD'
];

export const EMPLOYMENT_STATUS_OPTIONS = [
  'Employed', 'Self Employed', 'Unemployed', 'Student', 'Retired'
];

export const LOAN_PURPOSES = [
  'Business', 'Education', 'Medical', 'Emergency', 'Personal', 'Agriculture', 'Other'
];